import React, { useEffect, useRef, useState } from "react";
import { getBrandStorePackageOfferConfig } from "../../../services/PaymentOfferManagement/PackageOfferMangementConfig";
import { addCustomerPackageOffer, GenerateSubscriptionPaymentLink, GenerateSubscriptionPaymentQr, ReGenerateSubscriptionPaymentLink, SubscriptionPaymentQr } from "../../../services/CustomerPackageOffer/CustomerPackageOffer";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import SuccessModal from "../../SuccessModal";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { getViewPaymentMode, getViewPaymentModeV2 } from "../../../services/paymentMode/paymentMode";
import { STORE_BASE_URL } from "../../../services/BaseURL";

import QRCode from "qrcode";
import { getLocalStorePaymentGatewayConfig, getStoreLocalData } from "../../../utils/localStorage";
import { getStorePaymentGatewayConfig } from "../../../services/PaymentGatewayConfig/PaymentGatewayConfig";

const DISPLAY_W = 320;
const DISPLAY_H = 480;

const CustomerStorePackageOfferAddModalAdmin = ({
  customerStorePackageOfferModalVisible,
  setCustomerStorePackageOfferModalVisible,
  sendDataToCustomerPackageOffer,
  brandId,
  storeCustomerId,
  storeId,
  storeUserId,
  gstValue,
  storeGstNumber,
  storeGstType,
  enabledUPIAccount,
  upiAccountId,
  upiAccountLink,
  upiAccountName,
  enabledQRDeviceModal,
}) => {
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [brandPackageOffers, setBrandPackageOffers] = useState([]);
  const [packageOfferValue, setPackageOfferValue] = useState("");
  const [paymentMethodValue, setPaymentMethodValue] = useState("");
  const [paymentModeData, setPaymentModeData] = useState([]);
  const [selectedPackageOfferData, setSelectedPackageOfferData] = useState({});
  const [resendPaymentLink, setResendPaymentLink] = useState(false)

  const { storeLocalData } = getStoreLocalData();

  const SubscriptionAmountValue = storeGstNumber ? Math.round(selectedPackageOfferData?.brandPackageOfferDTO?.packageValue + (selectedPackageOfferData?.brandPackageOfferDTO?.packageValue * (gstValue / 100))) : Math.round(selectedPackageOfferData?.brandPackageOfferDTO?.packageValue)

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  const [paymentQrRes, setPaymentQrRes] = useState({})
  const [paymentLinkRes, setPaymentLinkRes] = useState({})
  const [paymentLinkReGenerationRes, setPaymentLinkReGenerationRes] = useState({})
  const [subscriptionPaymentQrRes, setSubscriptionPaymentQrRes] = useState({})


  const [storePaymentGatewayData, setStorePaymentGatewayData] = useState([]);

  const fetchStorePaymentGatewayConfig = async () => {
    try {
      const response = await getStorePaymentGatewayConfig(storeId);
      if (!response.data.error) {
        const Res = response.data;
        setStorePaymentGatewayData(Res);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchPaymentMode = () => {
    getViewPaymentModeV2(brandId)
      .then((response) => {
        if (!response.data.error) {
          // const Res = response.data?.paymentModeList?.Location2.filter(
          //   (item) => item !== "ONLINE" && item !== "USER_ACCOUNT" && item !== "CASH" && item !== "COD"
          // );
          const Res = response.data?.paymentModes.filter(
            (item) => item !== "USER_ACCOUNT"
          );
          setPaymentModeData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    getBrandStorePackageOfferConfig(brandId, storeId)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          const activePackageOffer = res.filter((item) => (
            item.status === true && item?.brandPackageOfferDTO?.status === "ACTIVE"
          ))
          const packageOffer = activePackageOffer.map((item, index) => ({
            name: item.brandPackageOfferDTO.name,
            code: item.brandPackageOfferDTO.id,
            data: item,
          }));
          setBrandPackageOffers(packageOffer);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
    fetchPaymentMode();
    fetchStorePaymentGatewayConfig();
  }, []);

  const fetchSubscriptionPaymentQr = (orderId) => {
    SubscriptionPaymentQr(brandId, storeId, orderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setSubscriptionPaymentQrRes(Res);

          if (enabledQRDeviceModal && Res?.transactionId) {
            // if (Res?.transactionId) {
            handleSendQr(Res?.transactionId)
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }

  const intervalRef = useRef(null);

  useEffect(() => {
    if (!paymentQrRes?.orderId) return;

    intervalRef.current = setInterval(() => {
      fetchSubscriptionPaymentQr(paymentQrRes.orderId);
    }, 5000);

    return () => clearInterval(intervalRef.current);
  }, [paymentQrRes?.orderId]);

  useEffect(() => {
    if (subscriptionPaymentQrRes?.processed && intervalRef.current) {
      if (subscriptionPaymentQrRes?.processed === true) {
        setModalVisible(true);
        setModalStatus("success");
        setModalText(subscriptionPaymentQrRes?.status);
      } else {
        setModalVisible(true);
        setModalStatus("not Success");
        setModalText(subscriptionPaymentQrRes?.status);
      }
      clearInterval(intervalRef.current);
      setTimeout(() => {
        setSelectedStatus([]);
        setIsSubmitButtonPressed(false);
        setPackageOfferValue("");
        setSelectedPackageOfferData("");
        setPaymentMethodValue("");
        setCustomerStorePackageOfferModalVisible(false);
      }, 2000);
      sendDataToCustomerPackageOffer({
        success: true,
      });
    }
  }, [subscriptionPaymentQrRes?.processed]);

  const handlePackageOfferValueChange = (selectedItem) => {
    setPackageOfferValue(selectedItem);
    setSelectedPackageOfferData(selectedItem.data);
  };

  const handlePaymentMethodChange = (charge) => {
    setPaymentMethodValue(charge);
  };

  const handleSubscriptionPurchase = () => {
    if (!isSubmitButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsSubmitButtonPressed(true);

      const data = {
        receivedBy: storeUserId,
        paidBy: storeCustomerId,
        amount: SubscriptionAmountValue,
        paymentMode: paymentMethodValue,
      };
      const updatedData = {
        status: "ACTIVE",
        brandPackageOffer: {
          id: selectedPackageOfferData.brandPackageOfferDTO.id,
        },
        storeCustomerId: storeCustomerId,
        paymentDTO: data,
      };

      addCustomerPackageOffer(brandId, storeId, updatedData)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            if (Res) {
              const message = Res.message;
              const status = Res.status;

              if (status === true) {
                setModalVisible(true);
                setModalStatus("success");
                setModalText(message);
              } else if (message === "Already exist!") {
                setModalVisible(true);
                setModalStatus("not Success");
                setModalText(message);
              } else {
                setModalVisible(true);
                setModalStatus("not Success");
                setModalText(message);
              }
              setTimeout(() => {
                setSelectedStatus([]);
                setIsSubmitButtonPressed(false);
                setPackageOfferValue("");
                setSelectedPackageOfferData("");
                setPaymentMethodValue("");
                setCustomerStorePackageOfferModalVisible(false);
              }, 2000);
              sendDataToCustomerPackageOffer({
                success: true,
              });
            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  const handleModalClose = () => {
    setCustomerStorePackageOfferModalVisible(false);
    setSelectedStatus([]);
    setPackageOfferValue("");
    setPaymentMethodValue("");
    setSelectedPackageOfferData("");
  };

  const [qrRes, setQrRes] = useState("")
  const [qrResStatus, setQrResStatus] = useState(false)

  const [paymentDone, setPaymentDone] = useState(false);


  useEffect(() => {
    let intervalId;
    let timeoutId;
    let isCompleted = false; // ✅ prevents double execution

    if (qrResStatus && !paymentDone) {
      intervalId = setInterval(async () => {

        if (subscriptionPaymentQrRes?.processed && !isCompleted) {
          isCompleted = true;

          clearInterval(intervalId);
          clearTimeout(timeoutId);

          setPaymentDone(true);

          await sendScreen("success", "");

          setTimeout(() => {
            setSelectedStatus([]);
            setIsSubmitButtonPressed(false);
            setPackageOfferValue("");
            setSelectedPackageOfferData("");
            setPaymentMethodValue("");
            setCustomerStorePackageOfferModalVisible(false);
          }, 2000);
          sendDataToCustomerPackageOffer({
            success: true,
          });
        }
      }, 5000);

      // ✅ 30 sec timeout
      timeoutId = setTimeout(async () => {
        if (!isCompleted) {
          isCompleted = true;

          clearInterval(intervalId);

          setPaymentDone(true);

          await sendScreen("fail", "");

          setCustomerStorePackageOfferModalVisible(false);

          sendDataToCustomerPackageOffer({
            success: true,
          });

          setQrRes("Payment timeout");
        }
      }, 300000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [qrResStatus, paymentDone, subscriptionPaymentQrRes?.processed]);

  // ---------------- HELPERS ----------------

  function getBaseUrl() {
    return `http://127.0.0.1:8053`;
  }

  function getEndpoint(type) {
    return {
      qr: "/rgb565/qr",
      success: "/rgb565/success",
      fail: "/rgb565/fail",
    }[type];
  }

  function drawCenteredText(ctx, text, font, y) {
    ctx.font = font;
    ctx.fillStyle = "black";
    const x = (DISPLAY_W - ctx.measureText(text).width) / 2;
    ctx.fillText(text, x, y);
  }

  function toRGB565Blob(canvas) {
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    const data = ctx.getImageData(0, 0, DISPLAY_W, DISPLAY_H).data;

    const out = new Uint8Array(DISPLAY_W * DISPLAY_H * 2);
    let idx = 0;

    for (let i = 0; i < DISPLAY_H; i++) {
      for (let j = 0; j < DISPLAY_W; j++) {
        const src = ((DISPLAY_H - 1 - i) * DISPLAY_W + j) * 4;

        const r = (data[src] >> 3) & 0x1f;
        const g = (data[src + 1] >> 2) & 0x3f;
        const b = (data[src + 2] >> 3) & 0x1f;

        const px = (r << 11) | (g << 5) | b;

        out[idx++] = (px >> 8) & 0xff;
        out[idx++] = px & 0xff;
      }
    }

    return new Blob([out], { type: "application/octet-stream" });
  }

  async function fetchImage(url) {
    const resp = await fetch(url);
    if (!resp.ok) throw new Error("Image load failed");

    const blob = await resp.blob();
    const objectUrl = URL.createObjectURL(blob);

    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(objectUrl);
        resolve(img);
      };
      img.onerror = reject;
      img.src = objectUrl;
    });
  }

  async function drawBackground(url) {
    const canvas = document.getElementById("canvas");
    canvas.width = DISPLAY_W;
    canvas.height = DISPLAY_H;

    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    ctx.clearRect(0, 0, DISPLAY_W, DISPLAY_H);

    const img = await fetchImage(url);
    ctx.drawImage(img, 0, 0, DISPLAY_W, DISPLAY_H);

    return ctx;
  }

  // ---------------- CORE RENDER ----------------

  async function renderScreen(type, transactionId) {

    const upiAccountLinkCreated =
      "upi://pay?pa=" +
      upiAccountId +
      "&pn=" +
      upiAccountName +
      "&tr=MNO" +
      transactionId +
      "&am=" +
      SubscriptionAmountValue +
      "&cu=INR&mc=5411"

    const canvas = document.getElementById("canvas");
    const ctx = canvas.getContext("2d", { willReadFrequently: true });

    if (type === "qr") {
      await drawBackground(
        "https://download.rechargegrid.in/download/general/image/jpeg/_background.jpg"
      );

      const overlayCanvas = document.getElementById("overlayCanvas");

      await QRCode.toCanvas(overlayCanvas, upiAccountLinkCreated, {
        width: 260,
        margin: 1,
      });

      ctx.drawImage(overlayCanvas, 30, 150, 260, 260);

      drawCenteredText(ctx, storeLocalData?.currencySymbol + " " + SubscriptionAmountValue, "bold 30px Arial", 130);
      drawCenteredText(ctx, "UPI ID: " + upiAccountId, "20px Arial", 440);
    }

    if (type === "fail") {
      await drawBackground("https://download.rechargegrid.in/download/general/image/jpeg/_fail.jpg");
      return;
    }

    if (type === "success") {
      await drawBackground(
        "https://download.rechargegrid.in/download/general/image/jpeg/_success.jpg"
      );

      drawCenteredText(
        ctx,
        storeLocalData?.currencySymbol + " " + (SubscriptionAmountValue || "0.00"),
        "32px Arial",
        260
      );
    }
  }

  // ---------------- SEND TO DEVICE ----------------

  async function sendScreen(type, transactionId) {
    try {
      await renderScreen(type, transactionId);

      const endpoint = getEndpoint(type);
      if (!endpoint) throw new Error("Invalid type");

      const canvas = document.getElementById("canvas");

      const fd = new FormData();
      fd.append("file", toRGB565Blob(canvas), "image.bin");

      const resp = await fetch(getBaseUrl() + endpoint, {
        method: "POST",
        body: fd,
      });

      const text = await resp.text();

      if (resp.status === 200 && type === "qr") {
        setQrResStatus(true);
      }

      setQrRes("Response: " + text);
    } catch (err) {
      setQrRes("Error: " + err.message);
    }
  }

  // ---------------- BUTTON ----------------

  const handleSendQr = (transactionId) => {
    setPaymentDone(false); // reset
    sendScreen("qr", transactionId);
    // sendScreen("success");
  };

  const handleSubscriptionQrPayment = () => {
    if (!isSubmitButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsSubmitButtonPressed(true);

      const data = {
        receivedBy: storeUserId,
        paidBy: storeCustomerId,
        amount: SubscriptionAmountValue,
        paymentMode: paymentMethodValue,
      };
      const updatedData = {
        status: "ACTIVE",
        brandPackageOffer: {
          id: selectedPackageOfferData.brandPackageOfferDTO.id,
        },
        storeCustomerId: storeCustomerId,
        paymentDTO: data,
      };

      GenerateSubscriptionPaymentQr(brandId, storeId, updatedData)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            if (Res) {
              setPaymentQrRes(Res)
              const message = Res.message;
              const status = Res.status;

            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  const handleSubscriptionPaymentLink = () => {
    if (!isSubmitButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsSubmitButtonPressed(true);

      const updatedData = {
        storeGatewayId: storePaymentGatewayData[0]?.id,
        storeCustomerId: storeCustomerId,
        requestAmount: SubscriptionAmountValue,
        notify: true,
        storeUserId: storeUserId,
        forceCreate: false,
        storeId: storeId,
        brandPackageOffer: {
          id: selectedPackageOfferData.brandPackageOfferDTO.id,
        }
      };

      GenerateSubscriptionPaymentLink(updatedData)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;

            if (Res) {
              setPaymentLinkRes(Res)
              const message = Res.message;
              const status = Res.status;

              if (status === true && message === "Success") {
                setModalVisible(true);
                setModalStatus("success");
                setModalText(message);
                setTimeout(() => {
                  setSelectedStatus([]);
                  setIsSubmitButtonPressed(false);
                  setPackageOfferValue("");
                  setSelectedPackageOfferData("");
                  setPaymentMethodValue("");
                  setCustomerStorePackageOfferModalVisible(false);
                }, 2000);
                sendDataToCustomerPackageOffer({
                  success: true,
                });
              } else if (message === "Already exist!") {
                setModalVisible(true);
                setModalStatus("not Success");
                setModalText(message);
                setResendPaymentLink(true)
              } else {
                setModalVisible(true);
                setModalStatus("not Success");
                setModalText(message);
                setTimeout(() => {
                  setSelectedStatus([]);
                  setIsSubmitButtonPressed(false);
                  setPackageOfferValue("");
                  setSelectedPackageOfferData("");
                  setPaymentMethodValue("");
                  setCustomerStorePackageOfferModalVisible(false);
                }, 2000);
                sendDataToCustomerPackageOffer({
                  success: true,
                });
              }


            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  const handleSubscriptionPaymentLinkReGeneration = (paymentLinkRes) => {

    const id = paymentLinkRes.resCode

    ReGenerateSubscriptionPaymentLink(id)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          if (Res) {
            setPaymentLinkReGenerationRes(Res)
            const message = Res.message;
            const status = Res.status;




          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={customerStorePackageOfferModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!customerStorePackageOfferModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div></div>

              <p className=" text-3xl text-primary-50 font-semibold">
                ADD OFFER
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-xl text-primary-50 border-1 p-1"
              ></Button>
            </div>

            {resendPaymentLink ?

              <>

                <div className=" flex flex-column">
                  {paymentLinkReGenerationRes.resCode ? <div className="m-4">

                    <p className="text-lg text-center font-semibold">Payment Link {paymentLinkReGenerationRes.message}</p>
                    <p className="text-xl text-center font-semibold" style={{ color: 'blue' }}>{paymentLinkReGenerationRes.resCode}</p>
                  </div>
                  :
                  <div className="flex justify-content-between">

                    <Button
                      onClick={() => handleSubscriptionPaymentLinkReGeneration(paymentLinkRes)}
                      className="mt-1 mb-3 mx-4 border-round-xl w-full"
                    >
                      <p className=" w-full text-2xl font-semibold flex justify-content-center">
                        Re-Generate Link
                      </p>
                    </Button>
                  </div>
                  }
                </div>

              </> :
              <div className=" flex flex-column">
                <div className="inline-flex flex-column gap-2 mx-4 mb-2">
                  <Dropdown
                    value={packageOfferValue}
                    onChange={(e) => handlePackageOfferValueChange(e.value)}
                    options={brandPackageOffers}
                    placeholder="Package Offer"
                    optionLabel="name"
                    className="w-full  bg-white-alpha-20 border-round-lg p-0 text-lg text-primary-50"
                  />
                </div>
                <div className="inline-flex flex-column mx-4 mb-1">
                  <Dropdown
                    value={paymentMethodValue}
                    onChange={(e) => handlePaymentMethodChange(e.value)}
                    options={paymentModeData}
                    placeholder="Payment Method"
                    className="w-full  bg-white-alpha-20 border-round-lg p-0 text-lg text-primary-50"
                  />
                </div>

                <div style={{ display: "none" }} class="right">
                  <h3 >Preview</h3>
                  <canvas id="canvas" width="320" height="480"></canvas>
                  <canvas id="overlayCanvas" width="260" height="260" ></canvas>
                  <div id="status">Ready</div>
                </div>

                {Object.keys(selectedPackageOfferData).length > 0 && (
                  <div>
                    <div className="flex flex-column mx-4">
                      <p className="  font-semibold">Amount</p>
                      <InputText
                        value={SubscriptionAmountValue.toString()}
                        disabled={true}
                        id="amount"
                        label="Amount"
                        className="w-full text-2xl  border-round-lg p-2 text-lg"
                        style={{ color: "#000" }}
                      ></InputText>
                    </div>

                    <div
                      className=" shadow-5 surface-0 flex-1 mb-4 mx-4 border-round-lg"
                      style={{
                        backgroundImage:
                          "radial-gradient(circle at left top, #fff, #fff)",
                      }}
                    >
                      {paymentQrRes?.orderId ?
                        <div className="p-4 flex justify-content-center flex-column">

                          {subscriptionPaymentQrRes.processed ?

                            <p className="text-md font-normal capitalize text-center">Transaction Status : {subscriptionPaymentQrRes?.status}</p>

                            :
                            <div className="flex justify-content-center flex-column">
                              <p className="text-lg font-bold capitalize text-center">Please Scan To Pay</p>
                              <img
                                className="print-section"
                                src={STORE_BASE_URL + `/store/api/secure/v1/qr-code/qr-by-transaction/subs/` + paymentQrRes?.orderId + `/120/120`}
                                resizeMode="cover"
                                style={{
                                  alignSelf: "center", // to center an image
                                  // width: "100%",
                                }}
                              />
                              <p className="text-md font-normal capitalize text-center" style={{ color: "red" }}>* Please Do not close this window until payment is confirmed.</p>
                            </div>
                          }
                        </div>
                        :
                        <div className="px-4">
                          <div className="grid mt-1">
                            <div className="col">
                              <p className="text-md font-normal capitalize">
                                Garment Name :
                              </p>
                              <p className="text-lg font-semibold capitalize">
                                {selectedPackageOfferData?.brandPackageOfferDTO?.name.replace(
                                  /_/g,
                                  " "
                                )}
                              </p>
                            </div>

                            <div className="col">
                              <p className="text-md font-normal capitalize">
                                Category :
                              </p>
                              <p className="text-lg font-semibold capitalize">
                                {selectedPackageOfferData?.brandPackageOfferDTO?.offerCategory.name.replace(
                                  /_/g,
                                  " "
                                )}
                              </p>
                            </div>
                          </div>

                          <div className="grid">
                            <div className="col">
                              <p className="text-md font-normal capitalize">
                                Days To Consume :
                              </p>
                              <p className="text-lg font-semibold capitalize">
                                {
                                  selectedPackageOfferData?.brandPackageOfferDTO
                                    ?.validity
                                }
                              </p>
                            </div>

                            <div className="col">
                              <p className="text-md font-normal capitalize">
                                Discount :
                              </p>
                              <p className="text-lg font-semibold capitalize">
                                {
                                  selectedPackageOfferData?.brandPackageOfferDTO
                                    ?.value
                                }{" "}
                                %
                              </p>
                            </div>
                          </div>

                          <div className="grid">
                            <div className="col">
                              <p className="text-md font-normal capitalize">
                                Service Value :
                              </p>
                              <p className="text-lg font-semibold capitalize">
                                {
                                  selectedPackageOfferData?.brandPackageOfferDTO
                                    ?.serviceValue
                                }
                              </p>
                            </div>

                            <div className="col">
                              <p className="text-md font-normal capitalize">
                                Package Value :
                              </p>
                              <p className="text-lg font-semibold capitalize">
                                {
                                  selectedPackageOfferData?.brandPackageOfferDTO
                                    ?.packageValue
                                }
                              </p>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                )}
                {paymentMethodValue !== 'ICICI_PG' ? <Button
                  onClick={() => handleSubscriptionPurchase()}
                  className="mt-1 mb-3 mx-4 border-round-xl "
                  disabled={
                    (paymentMethodValue === '' && true) || isSubmitButtonPressed
                  }
                >
                  <p className=" w-full text-2xl font-semibold flex justify-content-center">
                    ADD
                  </p>
                </Button> :
                  paymentQrRes?.orderId ? <Button
                    onClick={() => handleModalClose()}
                    className="mt-1 mb-3 mx-4 border-round-xl "
                  >
                    <p className=" w-full text-2xl font-semibold flex justify-content-center">
                      Close
                    </p>
                  </Button> :

                    <div className="flex justify-content-between">
                      <Button
                        onClick={() => handleSubscriptionQrPayment()}
                        className="mt-1 mb-3 mx-4 border-round-xl w-full "
                        disabled={
                          (paymentMethodValue === '' && true) || isSubmitButtonPressed
                        }
                      >
                        <p className=" w-full text-2xl font-semibold flex justify-content-center">
                          Generate QR
                        </p>
                      </Button>
                      {storePaymentGatewayData[0]?.brandPaymentGatewayInfo
                        .gatewayName && <Button
                          onClick={() => handleSubscriptionPaymentLink()}
                          className="mt-1 mb-3 mx-4 border-round-xl w-full"
                          disabled={
                            (paymentMethodValue === '' && true) || isSubmitButtonPressed
                          }
                        >
                          <p className=" w-full text-2xl font-semibold flex justify-content-center">
                            Generate Link
                          </p>
                        </Button>}
                    </div>
                }
              </div>
            }
          </div>
        )}
      ></Dialog>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default CustomerStorePackageOfferAddModalAdmin;
